import {AxiosResponse} from "axios";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {toQueryParams} from "../queryParams";
import {TEMPLATES_QUERY_KEY} from "../queryKeys";
import {ReachTemplatesRead} from "./types";

type Variables = {
  segmentIds: number[];
};

const getTemplatesBySegments = async ({segmentIds}: Variables): Promise<ReachTemplatesRead[]> => {
  const response = await axiosReachInstance.get<ReachTemplatesRead[], AxiosResponse<ReachTemplatesRead[]>>(
    `/templates/by-segments${toQueryParams("segment_ids", segmentIds)}`
  );
  return response.data;
};

export const useGetTemplatesBySegments = (
  variables: Variables,
  options?: BaseQueryOptions<ReachTemplatesRead[], Variables>
): BaseUseQueryResult<ReachTemplatesRead[]> =>
  useBaseQuery<ReachTemplatesRead[], Variables>(
    [TEMPLATES_QUERY_KEY, "by-segments", variables.segmentIds.join(",")],
    getTemplatesBySegments,
    variables,
    options
  );
